// Утилита для обновления доходов игроков на основе citiesCache
import {calcPlayerIncomeBreakdown} from "./income/calcPlayerIncomeBreakdown";

/**
 * Рассчитать доходы игроков с учётом блокировки ключевых точек вражескими отрядами.
 * Сам расчет по источникам — calcPlayerIncomeBreakdown (его же расшифровку
 * показывает панель статов в шапке), здесь — только итоги
 * @param {Array} players - Массив игроков
 * @param {Object} citiesCache - Кэш городов { [playerColor]: [city1, city2, ...] }
 * @param {Array} units - Массив отрядов (опционально)
 * @param {Object} hexes - Объект ячеек (опционально)
 * @param specialBuildings
 * @param round
 * @param buildingsDamage
 * @param gameType
 * @param ruinsIncomeRoundLimit - лимит раундов для окна увеличенного дохода
 *   руин, getRuinsIncomeRoundLimit(gameState); null — окна нет
 * @param isCitylessEconomyRule - правило «без городов — без монет»
 *   (checkIfCitylessEconomyRule(gameState)): без единого города нет и доплат к
 *   базовому доходу; false — только у записей, сделанных до правила
 * @returns {Array} Массив игроков с обновлёнными доходами
 */
export const updatePlayersIncome = (players, citiesCache, units = [], hexes, specialBuildings, round, buildingsDamage, gameType, ruinsIncomeRoundLimit, isCitylessEconomyRule = true) => (
  players.map((player) => {
    const {coinsIncome, winPointsIncome} = calcPlayerIncomeBreakdown(player, {
      citiesCache,
      units,
      hexes,
      specialBuildings,
      round,
      buildingsDamage,
      gameType,
      ruinsIncomeRoundLimit,
      isCitylessEconomyRule,
    });

    return {
      ...player,
      coinsIncome,
      winPointsIncome,
    };
  })
);
